import { getLoggedInUser } from '../../helpers/authUtils';
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILED,
  LOGOUT_USER,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILED,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILED,
  RESET_FORGOT_PASSWORD,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILED,
  DAILY_3WORDS_REQUEST,
  DAILY_3WORDS_SUCCESS,
  DAILY_3WORDS_FAILED,
} from './constants';

const INIT_STATE = {
  forgotPassword: {
    loading: false,
    error: null,
    passwordResetStatus: null,
  },
  daily3words: {
    loading: false,
    error: null,
    words: null,
  },
  user: getLoggedInUser(),
  loading: false,
  error: null,
  changePassword: {
    loading: false,
    error: null,
    success: false,
  },
};

const Auth = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true };
    case LOGIN_USER_SUCCESS:
      return { ...state, user: action.payload, loading: false, error: null };
    case LOGIN_USER_FAILED:
      return { ...state, error: action.payload, loading: false };
    case REGISTER_USER:
      return { ...state, loading: true };
    case REGISTER_USER_SUCCESS:
      return { ...state, user: action.payload, loading: false, error: null };
    case REGISTER_USER_FAILED:
      return { ...state, error: action.payload, loading: false };
    case LOGOUT_USER:
      return { ...state, user: null };
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          loading: true,
          error: null,
          passwordResetStatus: null,
        },
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          loading: false,
          error: null,
          passwordResetStatus: true,
        },
      };
    case FORGOT_PASSWORD_FAILED:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          loading: false,
          error: action.payload,
        },
      };
    case RESET_FORGOT_PASSWORD:
      return {
        ...state,
        forgotPassword: {
          loading: false,
          error: null,
          passwordResetStatus: null,
        },
      };
    // Change Password cases
    case CHANGE_PASSWORD:
      return {
        ...state,
        changePassword: { loading: true, error: null, success: false },
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePassword: { loading: false, error: null, success: true },
      };
    case CHANGE_PASSWORD_FAILED:
      return {
        ...state,
        changePassword: { loading: false, error: action.payload, success: false },
      };
    // Daily 3 Words cases
    case DAILY_3WORDS_REQUEST:
      return {
        ...state,
        daily3words: { loading: true, error: null, words: null },
      };
    case DAILY_3WORDS_SUCCESS:
      return {
        ...state,
        daily3words: { loading: false, error: null, words: action.payload },
      };
    case DAILY_3WORDS_FAILED:
      return {
        ...state,
        daily3words: { loading: false, error: action.payload, words: null },
      };
    default:
      return { ...state };
  }
};

export default Auth;
